<template>
  <div>
    <button @click.prevent.stop="GetDesign">Get Design</button>

    <div class="row">
      <div v-html="htmlData"></div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      htmlData: null
    };
  },
  mounted() {},
  methods: {
    GetDesign: function() {
      UserService.EjsViewer().then(response => {
        this.htmlData = response.data;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/UserManagement/ejsdesignview.vue